import CompanyRoutes from "../../../apiRoutes/CompanyRoutes";
import { GET, POST, POST_JSON } from "../../ConsumeApiController";
import { api } from "../../ConsumeApiController";

export async function getModifierGroups()
{
    const response = await GET(CompanyRoutes.Products.ModifierGroups.getAll);

    return response;
}

export async function createModifierGroup(name,selectionType)
{
    const route = CompanyRoutes.Products.ModifierGroups.create;
    const body = {
        name: name,
        selection_type: selectionType,
        required: 0
    };
    const response = await api.post(route,body)
    return response;
}

export async function deleteModifierGroup(id)
{
    const route = CompanyRoutes.Products.ModifierGroups.delete+id;
    const response = await api.delete(route);
    return response;
}